class BundleBuilder {
    constructor() {
      // Translations can be customized here
      this.translations = {
        // Cart messages
        emptyCartMessage: '+',
        addToBundle: 'Aggiungi',
        viewBundle: 'Prosegui ',
        addBundleToCart: 'Acquista Ora',
        addingToCart: 'Carico...',
        
        // Discount messages
        discountTier1Message: 'Aggiungi ancora {n} prodotti per il 10% di sconto',
        discountTier2Message: 'Aggiungi ancora {n} prodotti per il 15% di sconto',
        discountTier3Message: 'Aggiungi ancora {n} prodotti per il 20% di sconto',
        discountTier4Message: 'Aggiungi ancora {n} prodotti per il 25% di sconto',
        discountMaxMessage: 'Hai raggiunto il massimo sconto: 25%!',
        
        // Shipping messages
        shippingText: 'SPEDIZIONE:',
        shippingCalculating: 'CALCOLO...',
        shippingFree: 'GRATIS',
        
        // Checkout and pricing
        subtotalText: 'Totale Stimato:',
        itemsText: 'prodotto',
        viewBundleButton: 'Prosegui',
        
        // Error messages
        cartErrorMessage: 'Sorry, there was an error adding your bundle to cart. Please try again.'
      };
      
      this.bundleItems = [];
      this.bundleCart = document.querySelector('[data-bundle-cart]');
      this.bundleCartItems = document.querySelector('[data-bundle-cart-items]');
      this.bundleCartCount = document.querySelector('[data-bundle-cart-count]');
      this.bundleSubtotal = document.querySelector('[data-bundle-subtotal]');
      this.bundleShipping = document.querySelector('[data-bundle-shipping]');
      this.bundleCheckoutBtn = document.querySelector('[data-bundle-checkout]');
      this.addToCartButtons = document.querySelectorAll('.bundle-product-card__add-btn');
      this.productCards = document.querySelectorAll('.bundle-product-card');
      this.variantSelectors = document.querySelectorAll('[data-variant-select]');
      
      // Mobile elements
      this.mobileCartDrawer = document.querySelector('[data-bundle-mobile-cart]');
      this.mobileCartOverlay = document.querySelector('[data-bundle-mobile-cart-overlay]');
      this.mobileCartClose = document.querySelector('[data-bundle-mobile-cart-close]');
      this.mobileCartBody = this.mobileCartDrawer ? this.mobileCartDrawer.querySelector('.bundle-mobile-cart-drawer__body') : null;
      this.mobileCartBar = document.querySelector('[data-bundle-mobile-cart-bar]');
      this.mobileCartToggle = document.querySelector('[data-bundle-mobile-cart-toggle]');
      this.mobileCartCount = document.querySelector('[data-bundle-mobile-cart-count]');
      this.mobileCartSubtotal = document.querySelector('[data-bundle-mobile-cart-subtotal]');
      
      this.discountTiers = [
        { minItems: 7, discount: 0.25 }, // 25% for 7+
        { minItems: 5, discount: 0.20 }, // 20% for 5-6
        { minItems: 3, discount: 0.15 }, // 15% for 3-4
        { minItems: 2, discount: 0.10 },  // 10% for 2
        { minItems: 1, discount: 0.10 }  // 10% for 2
      ];
      
      // Discount code configurations for checkout
      this.discountCodes = {
        tier3: 'BUNDLE0XZ7H8701', // 10% discount code for 3 items
      };
      
      this.freeShippingThreshold = 4999; // €49.99
      this.standardShippingCost = 599; // €4.99
      this.storageKey = 'bundleBuilder_savedItems';
      this.isMobile = window.innerWidth < 992;
      
      this.init();
    }
  
    init() {
      // Listen for window resize to update mobile state
      window.addEventListener('resize', this.handleResize.bind(this));
      
      // Try to restore saved bundle first
      this.restoreSavedBundle();
      
      // Add original prices as data attributes for reference
      this.addToCartButtons.forEach(button => {
        const productId = button.dataset.productId;
        const productPrice = parseFloat(button.dataset.productPrice);
        const productCard = button.closest('.bundle-product-card');
        if (productCard) {
          productCard.dataset.originalPrice = productPrice;
        }
      });
      
      // Initialize event listeners
      this.addEventListeners();
      
      // Initialize product buttons and prices after bundle items have been restored
      if (this.bundleItems.length > 0) {
        console.log('Initializing bundle with saved items:', this.bundleItems.length);
      }
      
      // Update UI with current bundle state
      this.updateCart();
      this.updateProductPrices();
      this.updateProductButtons();
      this.updateMobileCart();
  
      // Initialize Judge.me reviews if available
      this.initJudgeMe();
  
      // Sticky filter bar only on scroll up (mobile UX)
      const filterBar = document.querySelector('.bundle-builder__filters');
      let lastScrollY = window.scrollY;
      let ticking = false;
      function onScroll() {
        if (!filterBar) return;
        const currentScrollY = window.scrollY;
        const rect = filterBar.getBoundingClientRect();
        // Only trigger hide/show if the filter bar is at the top (sticky)
        if (rect.top <= 0) {
          if (currentScrollY > lastScrollY) {
            // Scrolling down, hide filter bar
            filterBar.classList.add('bundle-builder__filters--hidden');
          } else if (currentScrollY < lastScrollY) {
            // Scrolling up, show filter bar
            filterBar.classList.remove('bundle-builder__filters--hidden');
          }
        } else {
          // If not sticky, always show
          filterBar.classList.remove('bundle-builder__filters--hidden');
        }
        lastScrollY = currentScrollY;
        ticking = false;
      }
      window.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(onScroll);
          ticking = true;
        }
      });
  
      // Universal modal trigger for <basic-modal> (product card, cart, etc.)
      document.body.addEventListener('click', function(e) {
        if (e.button !== 0) return;
        // Only trigger for elements with the js-modal-trigger class
        const trigger = e.target.closest('.js-modal-trigger[aria-controls^="PopupModal-popup_ingredients--"]');
        if (trigger) {
          e.preventDefault();
          const modalId = trigger.getAttribute('aria-controls');
          const modal = document.getElementById(modalId);
          if (modal && typeof modal.show === 'function') {
            modal.show();
          }
        }
      }, false);
    }
    
    handleResize() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 992;
      
      // If switching between mobile and desktop, update the UI
      if (wasMobile !== this.isMobile) {
        this.updateMobileCart();
      }
    }
  
    restoreSavedBundle() {
      try {
        const savedBundle = localStorage.getItem(this.storageKey);
        if (savedBundle) {
          const parsedBundle = JSON.parse(savedBundle);
          if (Array.isArray(parsedBundle) && parsedBundle.length > 0) {
            console.log('Restored saved bundle items:', parsedBundle.length);
            
            // Get available product IDs on the page
            const availableProductIds = Array.from(this.addToCartButtons).map(button => button.dataset.productId);
            console.log('Available product IDs on page:', availableProductIds.length);
            
            // Filter bundle items to only include products that are available on the current page
            this.bundleItems = parsedBundle.filter(item => {
              const isValid = item && item.id && item.title && item.price && item.image && item.quantity;
              const isAvailable = availableProductIds.includes(item.id);
              return isValid && isAvailable;
            });
            
            console.log('Valid bundle items after filtering:', this.bundleItems.length);
          } else {
            console.log('Saved bundle exists but is empty or invalid');
            this.bundleItems = [];
          }
        } else {
          console.log('No saved bundle found');
        }
      } catch (error) {
        console.error('Error restoring saved bundle:', error);
        // If there's an error, clear the saved bundle
        localStorage.removeItem(this.storageKey);
        this.bundleItems = [];
      }
    }
  
    saveBundle() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(this.bundleItems));
      } catch (error) {
        console.error('Error saving bundle:', error);
      }
    }
  
    clearSavedBundle() {
      localStorage.removeItem(this.storageKey);
    }
  
    initJudgeMe() {
      // If Judge.me is already loaded, refresh the badges
      if (typeof window.jdgm !== 'undefined' && window.jdgm.customizeBadges) {
        window.jdgm.customizeBadges();
      }
    }
  
    addEventListeners() {
      // Add event listeners to product buttons
      this.addToCartButtons.forEach(button => {
        button.addEventListener('click', this.handleAddToBundle.bind(this));
      });
  
      // Add event listener to checkout button
      if (this.bundleCheckoutBtn) {
        this.bundleCheckoutBtn.addEventListener('click', this.addBundleToCart.bind(this));
      }
      
      // Add event listeners to variant selectors
      this.variantSelectors.forEach(select => {
        select.addEventListener('change', this.handleVariantChange.bind(this));
      });
      
      // Mobile cart drawer event listeners
      if (this.mobileCartOverlay) {
        this.mobileCartOverlay.addEventListener('click', this.closeMobileCart.bind(this));
      }
      
      if (this.mobileCartClose) {
        this.mobileCartClose.addEventListener('click', this.closeMobileCart.bind(this));
      }
      
      if (this.mobileCartToggle) {
        this.mobileCartToggle.addEventListener('click', this.openMobileCart.bind(this));
      }
    }
    
    handleVariantChange(event) {
      const select = event.currentTarget;
      const selectedOption = select.options[select.selectedIndex];
      const productId = select.dataset.productId;
      const variantId = selectedOption.dataset.variantId;
      const variantPrice = selectedOption.dataset.variantPrice;
      const variantImageId = selectedOption.dataset.variantImageId;
      const variantImage = selectedOption.dataset.variantImage;
      const variantTitle = selectedOption.textContent.trim();
      
      // Find the product card container
      const productCard = select.closest('.bundle-product-item');
      if (!productCard) return;
      
      // Update the price display
      const priceElement = productCard.querySelector('.bundle-product-card__price');
      if (priceElement) {
        priceElement.dataset.productPrice = variantPrice;
        
        // Apply any active discount
        const discount = this.getCurrentDiscount();
        if (discount > 0) {
          const discountedPrice = variantPrice * (1 - discount);
          priceElement.innerHTML = `
            <span class="bundle-product-card__original-price">${this.formatMoney(variantPrice)}</span>
            <span class="bundle-product-card__discounted-price">${this.formatMoney(discountedPrice)}</span>
          `;
        } else {
          priceElement.innerHTML = this.formatMoney(variantPrice);
        }
      }
      
      // Update the add to bundle button
      const addButton = productCard.querySelector('.bundle-product-card__add-btn');
      if (addButton) {
        addButton.dataset.productId = variantId;
        addButton.dataset.productPrice = variantPrice;
        addButton.dataset.productImage = variantImage;
        addButton.dataset.variantTitle = variantTitle;
        
        // Check if this variant is in the cart and update button state
        const existingItem = this.bundleItems.find(item => item.id === variantId);
        
        if (existingItem) {
          // If this variant is in the cart, update the button to show quantity
          addButton.classList.add('in-bundle');
          addButton.innerHTML = `
            <div class="bundle-quantity-selector">
              <button class="bundle-quantity-btn bundle-quantity-decrease" data-action="decrease">-</button>
              <span class="bundle-quantity-num">${existingItem.quantity}</span>
              <button class="bundle-quantity-btn bundle-quantity-increase" data-action="increase">+</button>
            </div>
          `;
          
          // Add event listeners for the quantity buttons
          const decreaseBtn = addButton.querySelector('.bundle-quantity-decrease');
          const increaseBtn = addButton.querySelector('.bundle-quantity-increase');
          
          if (decreaseBtn) {
            decreaseBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              this.updateQuantity(variantId, existingItem.quantity - 1);
            });
          }
          
          if (increaseBtn) {
            increaseBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              this.updateQuantity(variantId, existingItem.quantity + 1);
            });
          }
          
          // Disable the main button click when in quantity selector mode
          addButton.onclick = (e) => e.stopPropagation();
        } else {
          // If this variant is not in the cart, show "Add to Bundle" button
          addButton.classList.remove('in-bundle');
          addButton.innerHTML = this.translations.addToBundle;
          
          // Re-enable the main button click
          addButton.onclick = this.handleAddToBundle.bind(this);
        }
      }
      
      // Update the product image if needed
      const productImage = productCard.querySelector('.bundle-product-card__primary-image');
      if (productImage) {
        // Look for the variant image in the hidden container
        const variantImagesContainer = productCard.querySelector('.bundle-product-variant-images');
        if (variantImagesContainer) {
          const variantImageElement = variantImagesContainer.querySelector(`[data-variant-id="${variantId}"]`);
          if (variantImageElement) {
            productImage.src = variantImageElement.src;
            productImage.alt = variantImageElement.alt;
          }
        }
      }
    }
    
    openMobileCart() {
      if (this.mobileCartDrawer) {
        this.mobileCartDrawer.classList.add('is-active');
        document.body.style.overflow = 'hidden'; // Prevent scrolling when drawer is open
        
        // Update mobile cart content
        this.syncMobileCartContent();
      }
    }
    
    closeMobileCart() {
      if (this.mobileCartDrawer) {
        this.mobileCartDrawer.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    }
    
    syncMobileCartContent() {
      if (!this.mobileCartBody || !this.bundleCart) return;
      
      // Clone the cart content for the mobile drawer
      const cartContent = this.bundleCart.querySelector('.bundle-cart__content');
      const cartFooter = this.bundleCart.querySelector('.bundle-cart__footer');
      
      if (cartContent && cartFooter) {
        // Clear mobile cart body
        this.mobileCartBody.innerHTML = '';
        
        // Clone content section (with items) and append to mobile cart
        const contentClone = cartContent.cloneNode(true);
        this.mobileCartBody.appendChild(contentClone);
        
        // Clone footer section and append to mobile cart
        const footerClone = cartFooter.cloneNode(true);
        this.mobileCartBody.appendChild(footerClone);
        
        // Re-attach event listeners to remove buttons in the cloned content
        const removeButtons = this.mobileCartBody.querySelectorAll('[data-action="remove"]');
        removeButtons.forEach(button => {
          const itemId = button.closest('[data-item-id]').dataset.itemId;
          button.addEventListener('click', () => this.removeFromBundle(itemId));
        });
        
        // Re-attach event listeners to quantity selectors in the cloned content
        const quantitySelectors = this.mobileCartBody.querySelectorAll('.bundle-quantity-selector');
        quantitySelectors.forEach(selector => {
          const itemId = selector.closest('[data-item-id]')?.dataset.itemId;
          if (itemId) {
            const decreaseBtn = selector.querySelector('.bundle-quantity-decrease');
            const increaseBtn = selector.querySelector('.bundle-quantity-increase');
            
            if (decreaseBtn) {
              decreaseBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                const item = this.bundleItems.find(item => item.id === itemId);
                if (item) this.updateQuantity(itemId, item.quantity - 1);
              });
            }
            
            if (increaseBtn) {
              increaseBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                const item = this.bundleItems.find(item => item.id === itemId);
                if (item) this.updateQuantity(itemId, item.quantity + 1);
              });
            }
          }
        });
        
        // Re-attach event listener to checkout button
        const checkoutBtn = this.mobileCartBody.querySelector('[data-bundle-checkout]');
        if (checkoutBtn) {
          checkoutBtn.addEventListener('click', this.addBundleToCart.bind(this));
        }
        
        // Update the cart header with discount info
        this.updateCartHeader();
      }
    }
    
    updateMobileCart() {
      if (!this.isMobile) {
        // Hide mobile elements on desktop
        if (this.mobileCartBar) {
          this.mobileCartBar.classList.remove('is-active');
        }
        if (this.mobileCartDrawer) {
          this.mobileCartDrawer.classList.remove('is-active');
        }
        return;
      }
      
      // Update mobile cart bar
      if (this.mobileCartBar) {
        const hasItems = this.bundleItems.length > 0;
        
        if (hasItems) {
          this.mobileCartBar.classList.add('is-active');
          
          // Get discount and subtotal information
          const discount = this.getCurrentDiscount();
          const originalSubtotal = this.bundleItems.reduce((total, item) => total + (item.price * item.quantity), 0);
          const discountedSubtotal = discount > 0 ? originalSubtotal * (1 - discount) : originalSubtotal;
          
          // Update price display in the bar with original price, discounted price and percentage
          if (this.mobileCartCount && this.mobileCartSubtotal) {
            if (discount > 0) {
              // If there's a discount, show original price, discounted price and discount percentage
              const discountPercentText = `-${(discount * 100).toFixed(0)}%`;
              
              this.mobileCartCount.innerHTML = `<span class="bundle-mobile-cart-bar__original-price">${this.formatMoney(originalSubtotal)}</span>`;
              this.mobileCartSubtotal.innerHTML = `
                <span class="bundle-mobile-cart-bar__discounted-price">${this.formatMoney(discountedSubtotal)}</span>
                <span class="bundle-mobile-cart-bar__discount-percent">${discountPercentText}</span>
              `;
            } else {
              // If no discount, just show the subtotal
              const totalItems = this.bundleItems.reduce((total, item) => total + item.quantity, 0);
              this.mobileCartCount.textContent = `${totalItems} ${this.translations.itemsText}`;
              this.mobileCartSubtotal.textContent = this.formatMoney(originalSubtotal);
            }
          }
          
          // Update the toggle button text
          if (this.mobileCartToggle) {
            this.mobileCartToggle.textContent = this.translations.viewBundleButton;
          }
        } else {
          // Hide cart bar if no items
          this.mobileCartBar.classList.remove('is-active');
          this.closeMobileCart();
        }
      }
      
      // Make sure mobile cart content is up to date
      this.syncMobileCartContent();
    }
  
    handleAddToBundle(event) {
  const button = event.currentTarget;
  const productId = button.dataset.productId;
  const productTitle = button.dataset.productTitle;
  const productPrice = parseFloat(button.dataset.productPrice);
  const productImage = button.dataset.productImage;
  const variantTitle = button.dataset.variantTitle || '';

  // Check if product already exists in bundle
  const existingItem = this.bundleItems.find(item => item.id === productId);

  if (existingItem) {
    existingItem.quantity += 1;
  } else {
    this.bundleItems.push({
      id: productId,
      title: productTitle,
      price: productPrice,
      image: productImage,
      quantity: 1,
      variantTitle: variantTitle
    });
  }

  // ===== Trigger Meta Pixel AddToCart event =====
  if (typeof fbq !== 'undefined') {
    const discount = this.getCurrentDiscount();
    const discountedPrice = discount > 0 ? productPrice * (1 - discount) : productPrice;
    
    fbq('track', 'AddToCart', {
      content_ids: [productId],
      content_type: 'product',
      content_name: productTitle,
      value: (discountedPrice / 100).toFixed(2),
      currency: 'EUR',
      contents: [{
        id: productId,
        quantity: 1,
        item_price: (discountedPrice / 100).toFixed(2)
      }]
    });
  }
  
  // Trigger anche l'evento custom per altri tracciamenti
  document.dispatchEvent(
    new CustomEvent('bundle:product-added', {
      detail: {
        productId: productId,
        productTitle: productTitle,
        productPrice: productPrice,
        quantity: 1,
        discountedPrice: this.getDiscountedPrice(productPrice)
      },
    })
  );
  // ===== FINE Trigger eventi =====

  this.updateCart();
  this.updateProductPrices();
  this.updateProductButtons();
  this.updateMobileCart();
  this.saveBundle();
}
  
    removeFromBundle(productId) {
      this.bundleItems = this.bundleItems.filter(item => item.id !== productId);
      this.updateCart();
      this.updateProductPrices();
      this.updateProductButtons();
      this.updateMobileCart();
      this.saveBundle();
    }
  
    updateQuantity(productId, quantity) {
  const item = this.bundleItems.find(item => item.id === productId);
  if (item) {
    if (quantity < 1) {
      // Remove item completely if quantity becomes zero
      this.removeFromBundle(productId);
    } else {
      const oldQuantity = item.quantity;
      item.quantity = quantity;
      
      // ===== Trigger Meta Pixel se la quantità è aumentata =====
      if (quantity > oldQuantity && typeof fbq !== 'undefined') {
        const discount = this.getCurrentDiscount();
        const discountedPrice = discount > 0 ? item.price * (1 - discount) : item.price;
        const quantityDiff = quantity - oldQuantity;
        
        fbq('track', 'AddToCart', {
          content_ids: [productId],
          content_type: 'product',
          content_name: item.title,
          value: ((discountedPrice * quantityDiff) / 100).toFixed(2),
          currency: 'EUR',
          contents: [{
            id: productId,
            quantity: quantityDiff,
            item_price: (discountedPrice / 100).toFixed(2)
          }]
        });
      }
      // ===== FINE Trigger eventi =====
      
      this.updateCart();
      this.updateProductPrices();
      this.updateProductButtons();
      this.updateMobileCart();
      this.saveBundle();
    }
  }
}
  
    updateCart() {
      this.renderCartItems();
      this.updateCartCount();
      this.updateSubtotal();
      this.updateShipping();
      this.updateCartHeader();
      this.updateCheckoutButtonText();
      this.updateDiscountProgressBar();
    }
  
    updateCartHeader() {
      const discount = this.getCurrentDiscount();
      
      // Update desktop cart header
      const desktopHeader = document.querySelector('.bundle-cart__header');
      if (desktopHeader) {
        // Remove existing discount banner if any
        const existingBanner = desktopHeader.querySelector('.bundle-cart__header-discount');
        if (existingBanner) {
          existingBanner.remove();
        }
        
        // Add discount banner if there's an active discount
        if (discount > 0) {
          const discountBanner = document.createElement('div');
          discountBanner.className = 'bundle-cart__header-discount';
          discountBanner.innerHTML = `${this.getDiscountPercentText()} di sconto applicato!`;
          desktopHeader.appendChild(discountBanner);
        }
      }
      
      // Update mobile cart header
      const mobileHeader = document.querySelector('.bundle-mobile-cart-drawer__header');
      if (mobileHeader) {
        // Remove existing discount banner if any
        const existingBanner = mobileHeader.querySelector('.bundle-cart__header-discount');
        if (existingBanner) {
          existingBanner.remove();
        }
        
        // Add discount banner if there's an active discount
        if (discount > 0) {
          const discountBanner = document.createElement('div');
          discountBanner.className = 'bundle-cart__header-discount';
          discountBanner.innerHTML = `${this.getDiscountPercentText()} di sconto applicato!`;
          mobileHeader.appendChild(discountBanner);
        }
      }
    }
  
    getCurrentDiscount() {
      // Count total items including duplicates
      const totalItemCount = this.bundleItems.reduce((total, item) => total + item.quantity, 0);
      for (const tier of this.discountTiers) {
        if (totalItemCount >= tier.minItems) {
          return tier.discount;
        }
      }
      return 0;
    }
  
    getDiscountedPrice(originalPrice) {
      const discount = this.getCurrentDiscount();
      return originalPrice * (1 - discount);
    }
  
    getDiscountPercentText() {
      const discount = this.getCurrentDiscount();
      if (discount <= 0) return '';
      
      return `-${(discount * 100).toFixed(0)}%`;
    }
  
    updateProductPrices() {
      const totalItemCount = this.bundleItems.reduce((total, item) => total + item.quantity, 0);
      const allProductCards = document.querySelectorAll('.bundle-product-card');
      allProductCards.forEach(card => {
        const originalPrice = parseFloat(card.dataset.originalPrice);
        const priceElement = card.querySelector('.bundle-product-card__price');
        const imageContainer = card.querySelector('.bundle-product-card__image');
        // Rimuovi eventuale discount-tag precedente
        if (imageContainer) {
          const oldTag = imageContainer.querySelector('.bundle-product-card__discount-tag');
          if (oldTag) oldTag.remove();
        }
        // Calcola il prossimo tier per tutti i prodotti
        const nextCount = totalItemCount + 1;
        let nextDiscount = 0;
        for (const tier of this.discountTiers) {
          if (nextCount >= tier.minItems) {
            nextDiscount = tier.discount;
            break;
          }
        }
        const showDiscount = nextDiscount;
        const showDiscountText = nextDiscount > 0 ? `-${(nextDiscount * 100).toFixed(0)}%` : '';
        if (priceElement && originalPrice) {
          if (showDiscount > 0) {
            const discountedPrice = originalPrice * (1 - showDiscount);
            priceElement.innerHTML = `
              <span class="bundle-product-card__original-price">${this.formatMoney(originalPrice)}</span>
              <span class="bundle-product-card__discounted-price">${this.formatMoney(discountedPrice)}</span>
            `;
            card.classList.add('has-discount');
            // Inserisci il discount-tag sopra l'immagine
            if (imageContainer) {
              const discountTag = document.createElement('span');
              discountTag.className = 'bundle-product-card__discount-tag';
              discountTag.textContent = showDiscountText;
              imageContainer.appendChild(discountTag);
            }
          } else {
            priceElement.innerHTML = this.formatMoney(originalPrice);
            card.classList.remove('has-discount');
          }
        }
      });
    }
  
    updateProductButtons() {
      // Update all product buttons based on cart contents
      const allButtons = document.querySelectorAll('.bundle-product-card__add-btn');
      
      allButtons.forEach(button => {
        const productId = button.dataset.productId;
        const productItem = this.bundleItems.find(item => item.id === productId);
        const productCard = button.closest('.bundle-product-card');
        
        if (productItem) {
          // Product is in cart, show quantity selector
          button.classList.add('in-bundle');
          button.innerHTML = `
            <div class="bundle-quantity-selector">
              <button class="bundle-quantity-btn bundle-quantity-decrease" data-action="decrease">-</button>
              <span class="bundle-quantity-num">${productItem.quantity}</span>
              <button class="bundle-quantity-btn bundle-quantity-increase" data-action="increase">+</button>
            </div>
          `;
          
          // Add event listeners for the new buttons
          const decreaseBtn = button.querySelector('.bundle-quantity-decrease');
          const increaseBtn = button.querySelector('.bundle-quantity-increase');
          
          // Remove any existing event listeners
          if (decreaseBtn) {
            const newDecreaseBtn = decreaseBtn.cloneNode(true);
            decreaseBtn.parentNode.replaceChild(newDecreaseBtn, decreaseBtn);
            newDecreaseBtn.addEventListener('click', (e) => {
              e.stopPropagation(); // Prevent triggering the main button click
              this.updateQuantity(productId, productItem.quantity - 1);
            });
          }
          
          if (increaseBtn) {
            const newIncreaseBtn = increaseBtn.cloneNode(true);
            increaseBtn.parentNode.replaceChild(newIncreaseBtn, increaseBtn);
            newIncreaseBtn.addEventListener('click', (e) => {
              e.stopPropagation(); // Prevent triggering the main button click
              this.updateQuantity(productId, productItem.quantity + 1);
            });
          }
          
          // Disable the main button click when in quantity selector mode
          button.onclick = (e) => e.stopPropagation();
          
          if (productCard) {
            productCard.classList.add('in-bundle');
          }
        } else {
          // Product is not in cart, show "Add to Bundle" button
          button.classList.remove('in-bundle');
          button.innerHTML = this.translations.addToBundle;
          
          // Re-enable the main button click
          button.onclick = null;
          
          if (productCard) {
            productCard.classList.remove('in-bundle');
          }
        }
      });
    }
  
    renderCartItems() {
      if (!this.bundleCartItems) return;
  
      this.bundleCartItems.innerHTML = '';
  
      if (this.bundleItems.length === 0) {
        const emptyMessage = document.createElement('div');
        emptyMessage.className = 'bundle-cart__empty-message';
        emptyMessage.textContent = this.translations.emptyCartMessage;
        this.bundleCartItems.appendChild(emptyMessage);
        return;
      }
  
      this.bundleItems.forEach(item => {
        const itemElement = document.createElement('div');
        itemElement.className = 'bundle-cart-item';
        itemElement.dataset.itemId = item.id;
      //  itemElement.setAttribute('aria-controls', `PopupModal-popup_ingredients--${item.id}`);
      //  itemElement.setAttribute('aria-haspopup', 'dialog');
      //  itemElement.setAttribute('aria-expanded', 'false');
  
        const originalItemPrice = item.price;
        const discountedItemPrice = this.getDiscountedPrice(originalItemPrice);
        const currentDiscount = this.getCurrentDiscount();
        
        // Add variant title if available
        let fullTitle = item.title;
        
        // Add variant title if available
        if (item.variantTitle) {
          fullTitle += ` <span class="bundle-cart-item__variant-title">(${item.variantTitle})</span>`;
        }
        
        // Add quantity badge if more than 1
        const titleWithQuantity = item.quantity > 1 ? 
          `${fullTitle} <span class="bundle-cart-item__quantity-badge">x${item.quantity}</span>` : 
          fullTitle;
  
        // Show the price per item, not total
        const priceHtml = currentDiscount > 0
          ? `<div class="bundle-cart-item__price">
               <span class="bundle-cart-item__original-price">${this.formatMoney(originalItemPrice)}</span>
               <span class="bundle-cart-item__discounted-price">${this.formatMoney(discountedItemPrice)}</span>
               <span class="bundle-cart-item__discount-percent">${this.getDiscountPercentText()}</span>
             </div>`
          : `<div class="bundle-cart-item__price">${this.formatMoney(originalItemPrice)}</div>`;
  
        // Try to load Judge.me badge for this product from the page
        const productCard = document.querySelector(`.bundle-product-item[data-product-id="${item.id}"]`);
        let judgeMeBadge = '';
        
        if (productCard) {
          const badgeElement = productCard.querySelector('.jdgm-preview-badge');
          if (badgeElement) {
            judgeMeBadge = `<div class="bundle-cart-item__reviews">${badgeElement.outerHTML}</div>`;
          }
        }
  
        itemElement.innerHTML = `
          <div aria-controls="PopupModal-popup_ingredients--${item.id}" aria-haspopup="dialog" aria-expanded="false" class="bundle-cart-item__image js-modal-trigger">
            <img src="${item.image}" alt="${item.title}">
          </div>
          <div aria-controls="PopupModal-popup_ingredients--${item.id}" aria-haspopup="dialog" aria-expanded="false" class="bundle-cart-item__content js-modal-trigger">
            <div class="bundle-cart-item__title">${titleWithQuantity}</div>
            ${judgeMeBadge}
            ${priceHtml}
          </div>
          <button class="bundle-cart-item__remove" data-action="remove">&times;</button>
        `;
  
        // Add event listener for remove button only
        const removeBtn = itemElement.querySelector('[data-action="remove"]');
        removeBtn.addEventListener('click', () => this.removeFromBundle(item.id));
  
        this.bundleCartItems.appendChild(itemElement);
      });
    }
  
    updateCartCount() {
      if (!this.bundleCartCount) return;
      
      const totalItems = this.bundleItems.reduce((total, item) => total + item.quantity, 0);
      this.bundleCartCount.textContent = totalItems;
  
      if (totalItems > 0) {
        this.bundleCartCount.classList.add('has-items');
      } else {
        this.bundleCartCount.classList.remove('has-items');
      }
    }
  
    updateSubtotal() {
      if (!this.bundleSubtotal) return;
      
      const discount = this.getCurrentDiscount();
      const originalSubtotal = this.bundleItems.reduce((total, item) => total + (item.price * item.quantity), 0);
      const discountedSubtotal = discount > 0 ? originalSubtotal * (1 - discount) : originalSubtotal;
      
      // Update the subtotal display
      let subtotalHtml = '';
      if (discount > 0) {
        subtotalHtml = `
          <span class="bundle-cart__subtotal-original">${this.formatMoney(originalSubtotal)}</span>
          <span class="bundle-cart__subtotal-discounted">${this.formatMoney(discountedSubtotal)}</span>
          <span class="bundle-cart__subtotal-discount-percent">${this.getDiscountPercentText()}</span>
        `;
      } else {
        subtotalHtml = this.formatMoney(originalSubtotal);
      }
      
      this.bundleSubtotal.innerHTML = subtotalHtml;
    }
  
    updateShipping() {
      if (!this.bundleShipping) return;
      
      const shippingEl = this.bundleShipping.querySelector('.bundle-cart__shipping-price');
      if (!shippingEl) return;
      
      // If no items in bundle, show "Calculating..."
      if (this.bundleItems.length === 0) {
        shippingEl.textContent = this.translations.shippingCalculating;
        shippingEl.className = 'bundle-cart__shipping-price';
        return;
      }
      
      // Get the discounted subtotal
      const discount = this.getCurrentDiscount();
      const originalSubtotal = this.bundleItems.reduce((total, item) => total + (item.price * item.quantity), 0);
      const discountedSubtotal = discount > 0 ? originalSubtotal * (1 - discount) : originalSubtotal;
      
      // Free shipping over threshold
      if (discountedSubtotal >= this.freeShippingThreshold) {
        shippingEl.textContent = this.translations.shippingFree;
        shippingEl.className = 'bundle-cart__shipping-price bundle-cart__shipping-price--free';
      } else {
        // Show standard shipping cost
        shippingEl.textContent = this.formatMoney(this.standardShippingCost);
        shippingEl.className = 'bundle-cart__shipping-price bundle-cart__shipping-price--paid';
      }
    }
  
    formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      
      // Fallback money formatter if Shopify.formatMoney is not available - use EUR
      return (cents / 100).toFixed(2) + ' €';
    }
  
    async addBundleToCart() {
      // Controllo tipologie richieste
      const requiredTypes = [
        'Detersione',
        'Tonico',
        'Siero',
        'Crema',
        'Protezione',
        'Trattamento'
      ];
      // Trova le tipologie effettivamente disponibili (non esaurite)
      const availableTypes = new Set();
      document.querySelectorAll('.bundle-product-item').forEach(item => {
        const type = item.getAttribute('data-product-type');
        const addBtn = item.querySelector('.bundle-product-card__add-btn');
        if (addBtn && !addBtn.disabled) {
          availableTypes.add(type);
        }
      });
      // Trova le tipologie presenti nel bundle (usando variant id)
      const bundleTypes = new Set();
      this.bundleItems.forEach(item => {
        // Cerca il bundle-product-item che contiene la variante
        const el = document.querySelector(`.bundle-product-item [data-product-id="${item.id}"]`);
        const productItem = el ? el.closest('.bundle-product-item') : null;
        if (productItem) {
          const type = productItem.getAttribute('data-product-type');
          bundleTypes.add(type);
        }
      });
      // Tipologie richieste effettivamente disponibili
      const mustHave = requiredTypes.filter(t => availableTypes.has(t));
      // Tipologie mancanti
      const missing = mustHave.filter(t => !bundleTypes.has(t));
      if (missing.length > 0) {
        // Mostra modale upsell, NON bloccare il checkout
        const modal = document.getElementById('bundle-upsell-modal');
        const msg = document.getElementById('bundle-upsell-message');
        const productsDiv = document.getElementById('bundle-upsell-products');
        if (modal && msg && productsDiv) {
          msg.innerHTML = `<span style="display:block; font-size: 18px; font-weight: bold">Aspetta!</span> Per una routine completa ti consigliamo di aggiungere anche:`;
          // Modal session state: track add/remove while modal is open
          let modalSession = {};
          // On open, initialize modalSession with missing types
          mustHave.forEach(type => {
            const alreadyInBundle = this.bundleItems.some(item => {
              const el = document.querySelector(`.bundle-product-item [data-product-id="${item.id}"]`);
              const productItem = el ? el.closest('.bundle-product-item') : null;
              return productItem && productItem.getAttribute('data-product-type') === type;
            });
            if (!alreadyInBundle) modalSession[type] = false; // false = not in bundle
          });
          function renderUpsellProducts() {
            productsDiv.innerHTML = '';
            const baseCount = this.bundleItems.reduce((total, item) => total + item.quantity, 0);
            const sessionAddedCount = Object.values(modalSession).filter(v => v).length;
            // --- Discount message for modal ---
            const totalSimulated = baseCount + sessionAddedCount;
            
            // Use the same logic as updateProductPrices() - calculate discount for next product
            const nextCount = baseCount + 1;
            let nextDiscount = 0;
            for (const tier of this.discountTiers) {
              if (nextCount >= tier.minItems) {
                nextDiscount = tier.discount;
                break;
              }
            }
            // Generate discount message as in updateDiscountProgressBar, but for simulated count
            const tiers = this.discountTiers.slice().reverse();
            let nextTier = null;
            for (let i = 0; i < tiers.length; i++) {
              if (totalSimulated < tiers[i].minItems) {
                nextTier = tiers[i];
                break;
              }
            }
            const upsellMsgEl = document.getElementById('bundle-upsell-discount-message');
            if (upsellMsgEl) {
              if (nextTier) {
                const diff = nextTier.minItems - totalSimulated;
                const prodWord = diff === 1 ? 'prodotto' : 'prodotti';
                let msg = '';
                if (nextTier.minItems === 2) msg = this.translations.discountTier1Message.replace('{n}', diff).replace('prodotti', prodWord);
                else if (nextTier.minItems === 3) msg = this.translations.discountTier2Message.replace('{n}', diff).replace('prodotti', prodWord);
                else if (nextTier.minItems === 5) msg = this.translations.discountTier3Message.replace('{n}', diff).replace('prodotti', prodWord);
                else if (nextTier.minItems === 7) msg = this.translations.discountTier4Message.replace('{n}', diff).replace('prodotti', prodWord);
                upsellMsgEl.textContent = msg;
              } else {
                upsellMsgEl.textContent = this.translations.discountMaxMessage;
              }
            }
            // --- End discount message for modal ---
            // Limit to maximum 3 products in the modal
            const modalSessionKeys = Object.keys(modalSession).slice(0, 3);
            modalSessionKeys.forEach(type => {
              // Find the first available product of this type
              const productItem = Array.from(document.querySelectorAll('.bundle-product-item')).find(item => {
                return item.getAttribute('data-product-type') === type && item.querySelector('.bundle-product-card__add-btn') && !item.querySelector('.bundle-product-card__add-btn').disabled;
              });
              if (productItem) {
                const title = productItem.querySelector('.product-card__title')?.textContent || type;
                const img = productItem.querySelector('img')?.src;
                const btn = productItem.querySelector('.bundle-product-card__add-btn');
                let originalPrice = null;
                if (productItem.dataset.originalPrice) {
                  originalPrice = parseFloat(productItem.dataset.originalPrice);
                } else if (btn && btn.dataset.productPrice) {
                  originalPrice = parseFloat(btn.dataset.productPrice);
                }
                const inBundle = modalSession[type];
                let discountedPrice = originalPrice;
                let priceHtml = '';
                
                // Calculate the correct simulated count for this specific product
                let simulatedCount = baseCount;
                
                // Add count for products already added in this modal session
                Object.keys(modalSession).forEach(sessionType => {
                  if (modalSession[sessionType] === true) {
                    simulatedCount += 1;
                  }
                });
                
                // If this product is not in bundle yet, add 1 to simulate adding it
                if (!inBundle) {
                  simulatedCount += 1;
                }
                
                // Use the same discount logic as product cards
                let discount = nextDiscount;
                let discountPercentText = '';
                if (discount > 0) {
                  discountedPrice = originalPrice * (1 - discount);
                  discountPercentText = ` <span class='bundle-cart-item__discount-percent'>-${(discount * 100).toFixed(0)}%</span>`;
                  priceHtml = `<span style='text-decoration:line-through;color:#999;font-size:13px;margin-right:6px;'>${this.formatMoney(originalPrice)}</span><span style='color:#4A4A4A;font-weight:700;font-size:13px;'>${this.formatMoney(discountedPrice)}</span>${discountPercentText}`;
                } else {
                  priceHtml = `<span style='color:#4A4A4A;font-weight:700;font-size:13px;'>${this.formatMoney(originalPrice)}</span>`;
                }
                // Create mini card
                const div = document.createElement('div');
                div.style.display = 'flex';
                div.style.alignItems = 'center';
                div.style.justifyContent = 'space-between';
                div.style.margin = '8px 0';
                div.innerHTML = `
                  <div style="display:flex;align-items:center;gap:10px;">
                    <img src="${img}" alt="${title}" style="width:36px;height:36px;object-fit:cover;border-radius:6px;">
                    <div style="display:flex;flex-direction:column">
                    <span style="font-size:13px;">${title}</span>
                    <span style="text-align:left">${priceHtml}</span>
                    </div>
                  </div>
                  <button style="background:#4A4A4A;color:#fff;padding:6px 14px;border-radius:2.4rem;border:none;font-weight:600;cursor:pointer;font-size:14px;" data-upsell-action>${inBundle ? 'Rimuovi' : '+ Aggiungi'}</button>
                `;
                const actionBtn = div.querySelector('[data-upsell-action]');
                if (inBundle) {
                  actionBtn.onclick = () => {
                    this.removeFromBundle(btn.dataset.productId);
                    modalSession[type] = false;
                    setTimeout(() => renderUpsellProducts.call(this), 100);
                  };
                } else {
                  actionBtn.onclick = () => {
                    btn.click();
                    modalSession[type] = true;
                    setTimeout(() => renderUpsellProducts.call(this), 100);
                  };
                }
                productsDiv.appendChild(div);
              }
            });
          }
          renderUpsellProducts.call(this);
          modal.style.display = 'flex';
          // Chiudi modale al click sull'overlay (solo se click fuori dal box)
          modal.onclick = (e) => {
            if (e.target === modal) {
              modal.style.display = 'none';
            }
          };
        }
        // Gestione pulsanti
        const backBtn = document.getElementById('bundle-upsell-back');
        const proceedBtn = document.getElementById('bundle-upsell-proceed');
        if (backBtn) backBtn.onclick = () => { modal.style.display = 'none'; };
        if (proceedBtn) proceedBtn.onclick = (e) => { e.preventDefault(); modal.style.display = 'none'; this._proceedBundleToCart(); };
        return;
      }
      // Se tutto ok, procedi con checkout
      this._proceedBundleToCart();
    }
  
    // Nuova funzione: contiene il vecchio flusso checkout
    async _proceedBundleToCart() {
      if (this.bundleItems.length === 0) return;
      try {
        const bundleGroupId = 'bundle-' + Date.now(); // Add a timestamp to group the items
        
        // Add loading state
        const checkoutBtns = document.querySelectorAll('[data-bundle-checkout]');
        checkoutBtns.forEach(btn => {
          btn.classList.add('is-loading');
          btn.textContent = this.translations.addingToCart;
        });
  
        // Generate a unique bundle ID based on date and time
        const bundleId = Date.now().toString();
        const formData = {
          items: this.bundleItems.map(item => {
            const properties = {
              '_bundleId': bundleId,
              '_bundleType': 'Set'
            };
            // Add variant information if available
            if (item.variantTitle) {
              properties['_Variant'] = item.variantTitle;
            }
            return {
              id: item.id,
              quantity: item.quantity,
              properties: properties
            };
          })
        };
  
        // Add items to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });
  
        if (!response.ok) {
          throw new Error('Failed to add items to cart');
        }
  
        // Clear the saved bundle
        this.clearSavedBundle();
        // Also clear the in-memory bundle and update UI
        this.bundleItems = [];
        this.updateCart();
        this.updateProductPrices();
        this.updateProductButtons();
        this.updateMobileCart();
        this.saveBundle();
        this.updateCheckoutButtonText();
        this.closeMobileCart && this.closeMobileCart();
        // Wait a short moment to ensure Shopify processes the cart transform
        setTimeout(() => {
          // Trigger the cart drawer to refresh its contents and open
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          // Open the native cart drawer instead of reloading
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.show === 'function') {
            cartDrawer.show();
          }
        }, 500);
      } catch (error) {
        console.error('Error adding bundle to cart:', error);
        alert(this.translations.cartErrorMessage);
      } finally {
        const checkoutBtns = document.querySelectorAll('[data-bundle-checkout]');
        checkoutBtns.forEach(btn => {
          btn.classList.remove('is-loading');
          btn.textContent = this.translations.addBundleToCart;
        });
      }
    }
  
    updateCheckoutButtonText() {
      const checkoutBtns = document.querySelectorAll('[data-bundle-checkout]');
      const totalItems = this.bundleItems.reduce((total, item) => total + item.quantity, 0);
      checkoutBtns.forEach(btn => {
        if (totalItems < 2) {
          btn.textContent = 'Aggiungi almeno 2 prodotti';
          btn.disabled = true;
        } else {
          btn.innerHTML = `${this.translations.addBundleToCart} · <span class="bundle-cart__subtotal-price" data-bundle-subtotal>${this.bundleSubtotal ? this.bundleSubtotal.innerHTML : ''}</span>`;
          btn.disabled = false;
        }
      });
    }
  
    updateDiscountProgressBar() {
      const totalItemCount = this.bundleItems.reduce((total, item) => total + item.quantity, 0);
      const maxStep = 7;
      // Aggiorna messaggio
      const tiers = this.discountTiers.slice().reverse();
      let nextTier = null;
      for (let i = 0; i < tiers.length; i++) {
        if (totalItemCount < tiers[i].minItems) {
          nextTier = tiers[i];
          break;
        }
      }
      const messageEl = document.querySelector('[data-bundle-discount-message]');
      if (messageEl) {
        if (nextTier) {
          const diff = nextTier.minItems - totalItemCount;
          const prodWord = diff === 1 ? 'prodotto' : 'prodotti';
          let msg = '';
          if (nextTier.minItems === 2) msg = this.translations.discountTier1Message.replace('{n}', diff).replace('prodotti', prodWord);
          else if (nextTier.minItems === 3) msg = this.translations.discountTier2Message.replace('{n}', diff).replace('prodotti', prodWord);
          else if (nextTier.minItems === 5) msg = this.translations.discountTier3Message.replace('{n}', diff).replace('prodotti', prodWord);
          else if (nextTier.minItems === 7) msg = this.translations.discountTier4Message.replace('{n}', diff).replace('prodotti', prodWord);
          messageEl.textContent = msg;
        } else {
          messageEl.textContent = this.translations.discountMaxMessage;
        }
      }
      // Aggiorna progress bar
      const bar = document.querySelector('[data-bundle-progress-bar]');
      const fill = document.querySelector('[data-bundle-progress-bar-fill]');
      if (bar && fill) {
        const percent = Math.max(0, Math.min(100, (totalItemCount / maxStep) * 100));
        fill.style.width = percent + '%';
        fill.style.background = percent > 0 ? '#4A4A4A' : '#eee';
        // Evidenzia step raggiunti
        bar.querySelectorAll('.bundle-cart__progress-step').forEach(stepEl => {
          const step = parseInt(stepEl.getAttribute('data-step'));
          if (totalItemCount >= step) stepEl.classList.add('active');
          else stepEl.classList.remove('active');
        });
      }
    }
  }
  
  // Initialize the bundle builder when the DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new BundleBuilder();
  }); 